module.exports = __webpack_public_path__ + "img/aviation_system.4f674b1b.jpg";